<div class="card-wrap">
    <div class="card-inner">
  
      <div class="brand">
        <span class="brand-k">K</span><span class="brand-rest">onvac</span>
      </div>
  
      <!-- Step 1: request code -->
      <ng-container *ngIf="step === 'request'">
        <p class="tagline">Reset your password</p>
        <p class="sub-text">Enter your email and we'll send you a verification code.</p>
  
        <form (ngSubmit)="onRequestCode()" novalidate autocomplete="off">
  
          <div class="field-group">
            <label class="field-label">Email</label>
            <div class="input-wrap">
              <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                   fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
              <input type="email" class="field-input" placeholder="you@example.com"
                     [(ngModel)]="email" name="email" required autocomplete="email"/>
            </div>
          </div>
  
          <p class="error-msg"   *ngIf="errorMessage">{{ errorMessage }}</p>
          <p class="success-msg" *ngIf="successMessage">{{ successMessage }}</p>
  
          <button type="submit" class="login-btn" [class.loading]="loading" [disabled]="!emailValid || loading">
            <span class="btn-text" *ngIf="!loading">Send code</span>
            <span class="spinner" *ngIf="loading">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <circle cx="12" cy="12" r="10" stroke-opacity=".25"/>
                <path d="M12 2a10 10 0 0 1 10 10"/>
              </svg>
            </span>
          </button>
  
        </form>
      </ng-container>
  
      <!-- Step 2: enter code + new password -->
      <ng-container *ngIf="step === 'confirm'">
        <p class="tagline">Check your email</p>
        <p class="sub-text">Enter the code sent to <strong>{{ email }}</strong> and choose a new password.</p>
  
        <form (ngSubmit)="onConfirmCode()" novalidate autocomplete="off">
  
          <div class="field-group">
            <label class="field-label">Verification code</label>
            <div class="input-wrap">
              <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                   fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="7" width="20" height="14" rx="2"/>
                <path d="M16 3l-4 4-4-4"/>
              </svg>
              <input type="text" class="field-input" placeholder="123456"
                     [(ngModel)]="code" name="code" required autocomplete="one-time-code"
                     inputmode="numeric" maxlength="8"/>
            </div>
          </div>
  
          <div class="field-group">
            <label class="field-label">New password</label>
            <div class="input-wrap">
              <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                   fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
              <input [type]="showNew ? 'text' : 'password'" class="field-input" placeholder="Min. 8 characters"
                     [(ngModel)]="newPassword" name="newPassword" required autocomplete="new-password"/>
              <button type="button" class="toggle-pw" (click)="showNew = !showNew">
                <svg *ngIf="!showNew" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
                </svg>
                <svg *ngIf="showNew" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                  <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                  <line x1="1" y1="1" x2="23" y2="23"/>
                </svg>
              </button>
            </div>
          </div>
  
          <div class="field-group">
            <label class="field-label">Confirm new password</label>
            <div class="input-wrap">
              <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                   fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
              <input [type]="showConfirm ? 'text' : 'password'" class="field-input" placeholder="Repeat password"
                     [(ngModel)]="confirmPassword" name="confirmPassword" required autocomplete="new-password"/>
              <button type="button" class="toggle-pw" (click)="showConfirm = !showConfirm">
                <svg *ngIf="!showConfirm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
                </svg>
                <svg *ngIf="showConfirm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                  <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                  <line x1="1" y1="1" x2="23" y2="23"/>
                </svg>
              </button>
            </div>
            <p class="hint-msg" *ngIf="confirmPassword && !passwordsMatch">Passwords do not match.</p>
          </div>
  
          <p class="error-msg"   *ngIf="errorMessage">{{ errorMessage }}</p>
          <p class="success-msg" *ngIf="successMessage">{{ successMessage }}</p>
  
          <button type="submit" class="login-btn" [class.loading]="loading" [disabled]="!confirmFormValid || loading">
            <span class="btn-text" *ngIf="!loading">Set new password</span>
            <span class="spinner" *ngIf="loading">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <circle cx="12" cy="12" r="10" stroke-opacity=".25"/>
                <path d="M12 2a10 10 0 0 1 10 10"/>
              </svg>
            </span>
          </button>
  
          <button type="button" class="resend-link" (click)="resendCode()">
            Didn't receive a code? Resend
          </button>
  
        </form>
      </ng-container>
  
      <!-- Back link — always visible -->
      <button type="button" class="back-link" (click)="onBack()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/>
        </svg>
        Back to login
      </button>
  
    </div>
  </div>